import { atom } from 'recoil';
import { INotebook } from '@/types/notebook';

export const chatSettingsOpenState = atom<boolean>({
  key: 'chatSettingsOpen',
  default: false
});

export const chatSettingsSidebarOpenState = atom<boolean>({
  key: 'chatSettingsSidebarOpen',
  default: false
});

export const notebookOpenState = atom<boolean>({
  key: 'notebookOpen',
  default: false
});

export const notebooksState = atom<INotebook[]>({
  key: 'notebooks',
  default: []
});
